import React, { Component } from 'react'
import styled from 'styled-components';
import MS from '../../../commons/services/Moment';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTES } from '../../../commons/constants/routes/routes';
import { withTranslation } from 'react-i18next';

class HistoryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.handleTrClick = this.handleTrClick.bind(this);
  }

  handleTrClick (drHistory) {
    const { dt, logList } = drHistory;
    const date = MS.format(dt, "YYYY-MM-DD");
    this.props.history.push({
      pathname: ROUTES.DR,
      search: `?date=${date}`,
      state: {
        logIds: logList.map(log => log.drResourceIdx),
        date: date
      }
    });
  }
  
  render() {
    const { data = [], t } = this.props;

    return (
      <Table>
        <thead>
          <tr>
            <th>{t('key12')}</th>
            {/* <th>발령시간</th> */}
            <th>{t('key13')}</th>
          </tr>
        </thead>
        <tbody>
          {
            data?.map((drHistory, idx) => {
              const { dt, logList } = drHistory;
              const uniqueLogList = logList?.filter((log, idx, self) => self.findIndex(t => t.drResourceIdx === log.drResourceIdx) === idx);
              return (
                <tr key={idx} className='tb-tr' onClick={() => this.handleTrClick(drHistory)}>
                  <td>{MS.format(dt, "MM월 DD일")}</td>
                  <td>{uniqueLogList?.length || 0}개 활성화</td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>
    );
  }
}

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  & > thead {
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    border-bottom: 1px solid rgba(75, 81, 91, 1);
  }
  
  & > tbody > tr {
    height: 33px;
    line-height: 33px;
    font-size: 14px;
    text-align: center;
    border-bottom: 1px solid rgba(227, 229, 231, 1)
  }

  & > tbody > tr.tb-tr:hover {
    cursor: pointer;
    text-decoration: underline;
  }

`;

export default withTranslation()(withRouter(HistoryTable));